import { useMemo } from 'react'
import { useQuery } from '@based/sdk/react'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { isFeatureEnabled } from '@app/util/featureToggle'
import { regionsTabs } from '../constants'
import type { RegionsMunicipalitiesFeatures } from '@schema/featureToggle'
import {
  isRegionalLayoutTabAvailable,
  type RegionalLayoutTabAvailabilityContext,
} from './isRegionalLayoutTabAvailable'

export const useRegionalLayoutTabAvailability = (region: RegionViewModel) => {
  const expertsFeatureEnabled = isFeatureEnabled(
    region.featureToggles,
    regionsTabs.experts,
  )
  const locationsFeatureEnabled = isFeatureEnabled(
    region.featureToggles,
    regionsTabs.locations,
  )

  const expertsCountQuery = useQuery(
    expertsFeatureEnabled ? 'list-regional-service-providers' : null,
    { regionId: region.id, count: true },
  )
  const plotsCountQuery = useQuery(
    locationsFeatureEnabled ? 'list-regional-plot' : null,
    { regionId: region.id, count: true },
  )

  const context: RegionalLayoutTabAvailabilityContext = useMemo(
    () => ({
      expertsCount: expertsCountQuery.data?.count ?? 0,
      plotsCount: plotsCountQuery.data?.count ?? 0,
    }),
    [expertsCountQuery.data?.count, plotsCountQuery.data?.count],
  )

  const isTabAvailable = (tab: RegionsMunicipalitiesFeatures) =>
    isRegionalLayoutTabAvailable(region, tab, context)

  return { isTabAvailable, context }
}
